'use strict'
var ratings = angular.module('ratingsModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap'
]);
require('./allratings/js/directive/allratingsDirective.js')(ratings);
require('./allratings/js/allratingsController.js')(ratings);
require('./edit-newrating/js/directive/ratingDirective.js')(ratings);
require('./edit-newrating/js/ratingController.js')(ratings);



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/ratingModule/ratingModule.js
// module id = 578
// module chunks = 0